


import Facebook from './FacebookClone'
//import {AuthProvider} from './Facebook Clone/contexts/'
function App() {
  
  return (
    <>
    
    <div >
      <Facebook/>
    </div>
    </>
  );
}

export default App;
